import { render } from "./cpt-table.vue?vue&type=template&id=6a9b8252"
import script from "./cpt-table.vue?vue&type=script&lang=js"
export * from "./cpt-table.vue?vue&type=script&lang=js"

import "./cpt-table.vue?vue&type=style&index=0&id=6a9b8252&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__